





































































































import { Vue, Component, Watch } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import { isToday, format } from "date-fns";
import locale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en";
import UiMenu from "@dpa-id-components/ui-menu";
import UiList from "@dpa-id-components/ui-list";
import UiListItem from "@dpa-id-components/ui-list-item";
import UiButton from "@dpa-id-components/ui-button";
import deepEqual from "fast-deep-equal";
import "@dpa-id-components/ui-menu/dist/UiMenu.css";
import "@dpa-id-components/ui-list/dist/UiList.css";
import "@dpa-id-components/ui-list-item/dist/UiListItem.css";
import UiInfoContent from "@dpa-id-components/ui-info-content";
import "@dpa-id-components/ui-info-content/dist/UiInfoContent.css";
import UiIcon from "@dpa-id-components/ui-icon";
import "@dpa-id-components/ui-icon/dist/UiIcon.css";
import { computed } from "vue";
import SlcNewsItemProvider from "@/components/SlcNewsItem/SlcNewsItemProvider.vue"; // eslint-disable-line no-unused-vars
import CdkNewsItem from "@/components/CdkNewsItem/CdkNewsItem.vue"; // eslint-disable-line no-unused-vars
import { isMobile } from "@/utils/responsive";
import useMatomoEvent from "@/composition/useMatomoEvent";
import useFilterUtils from "@/composition/useFilterUtils";
import useSortedFolders from "@/composition/useSortedFolders";
import SlcSortOptions from "@/components/SlcSortOptions/SlcSortOptions.vue";
import SlcShareSearchButton from "@/components/SlcShareSearch/SlcShareSearchButton.vue";
import SlcSaveSearchButton from "@/components/SlcSaveSearch/SlcSaveSearchButton.vue";
import useVirtualScrollerStacking from "./lib/useVirtualScrollerStacking";
import maxZIndex from "./lib/useMaxZIndex";

import {
  isNotAFXItem,
  addStartOfDay,
  groupByStartOfDay,
  orderGroupsBySortOrder
} from "./lib/ListUtils";

@Component({
  components: {
    CdkNewsItem,
    SlcSortOptions,
    SlcNewsItemProvider,
    SlcShareSearchButton,
    SlcSaveSearchButton,
    UiList,
    UiListItem,
    UiMenu,
    UiButton,
    UiInfoContent,
    UiIcon
  },
  setup() {
    const { sortedFolders } = useSortedFolders();
    const { isSaveFilterEnabled } = useFilterUtils();
    const { onScrollerUpdate, scrollerRef } = useVirtualScrollerStacking();

    const handleSaveSearchClickEvent = () => {
      useMatomoEvent({
        category: "Search Results",
        action: 'Search Results "Suche speichern"',
        name: "Search Results Suche speichern"
      });
    };

    const handleShareSearchClickEvent = () => {
      useMatomoEvent({
        category: "Search Results",
        action: 'Search Results "Suche teilen"',
        name: "Search Results Suche teilen"
      });
    };

    return {
      sortedFolders,
      isSaveFilterEnabled,
      handleSaveSearchClickEvent,
      handleShareSearchClickEvent,
      onScrollerUpdate,
      scrollerRef,
      maxZIndex
    };
  },
  created() {
    const { path, query, params } = this.$route;
    if (!query.view) {
      this.$router.replace({
        path,
        params,
        query: {
          ...query,
          view: "long"
        }
      });
    }
  },
  props: {
    isUrgent: {
      type: Boolean,
      default: false
    }
  }
})
export default class List extends Vue {
  containerWidth = 0;

  isUrgent: boolean;

  // eslint-disable-next-line class-methods-use-this
  formatHeader(date: Date) {
    if (isToday(date)) {
      return this.$i18n.t("today");
    }
    const currentLanguage = computed(() => {
      return this.$i18n.locale;
    });

    const language = currentLanguage.value === "de" ? locale : enLocale;
    const languageSpecificDateFormat =
      currentLanguage.value === "de" ? "DD. MMMM YYYY" : "MMMM DD, YYYY";

    return format(date, languageSpecificDateFormat, { locale: language });
  }

  get sortOrder() {
    const { sortOrder } = this.$route.query;

    return sortOrder;
  }

  get isReversedByTime() {
    return this.sortOrder === "asc";
  }

  get newsItems() {
    const newsItems = this.$store.state.newsItems.newsItems
      .filter(isNotAFXItem(this.isUrgent))
      .map(addStartOfDay)
      .map(newsItem => ({ ...newsItem, id: newsItem.guid }));

    return newsItems;
  }

  get groupedNewsItems() {
    return groupByStartOfDay(this.newsItems);
  }

  get flattenedNewsItems() {
    const values = Object.values(this.groupedNewsItems);
    return values.reduce(
      (acc: Array<any>, dayItems: Array<any>) => [...acc, ...dayItems],
      []
    );
  }

  get hasNoSearchResults(): boolean {
    // @ts-ignore
    return this.flattenedNewsItems?.length === 0;
  }

  isFirstItemOfDate(newsItem, date) {
      return deepEqual(newsItem, this.groupedNewsItems[date]?.[0]);
    }

  isLastItemOfDate(newsItem, date) {
      return deepEqual(
        newsItem,
        this.groupedNewsItems[date]?.[this.groupedNewsItems[date].length - 1]
      );
    }

  get orderedGroups() {
    return orderGroupsBySortOrder(this.groupedNewsItems, this
      .sortOrder as string);
  }

  get isExpanded(): boolean {
    return (
      this.$route.query.view === "long" ||
      (this.$route.query.view === "short" && isMobile(this)) ||
      (this.$route.query.view === "short" && this.isContainerSamll)
    );
  }

  get uiState(): any {
    return this.$store.state.ui;
  }

  @Watch("uiState", { deep: true, immediate: true })
  onUiStateChange(): void {
    this.containerWidth = this.setContainerWidth();
  }

  get isContainerSamll(): boolean {
    return this.containerWidth < 960;
  }

  get totalResults(): string {
    const results = this.$store.state.newsItems.totalResults;
    return `${results > 1000 ? "> 1000" : results} `;
  }

  setContainerWidth(): number {
    return (
      window.innerWidth -
      (this.uiState.left ? this.uiState.leftWidth : 0) -
      (this.uiState.right ? this.uiState.rightWidth : 0)
    );
  }
}
